// extracted by mini-css-extract-plugin
module.exports = {"thumnail":"thumnail-module--thumnail--Ln1Kp","firstview":"thumnail-module--firstview--3JHJf","border":"thumnail-module--border--37awa"};